"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Anchor = exports.Box = exports.Graphic = exports.Flex = void 0;

var _tslib = require("tslib");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _slice = require("@lce/slice");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Flex = (0, _styledComponents["default"])(_slice.Flex)(templateObject_1 || (templateObject_1 = (0, _tslib.__makeTemplateObject)([""], [""])));
exports.Flex = Flex;
Flex.defaultProps = {
  justifyContent: 'center',
  m: '8% auto',
  p: 4
};
var Graphic = (0, _styledComponents["default"])(_slice.Graphic)(templateObject_2 || (templateObject_2 = (0, _tslib.__makeTemplateObject)(["\n  width: 250px;\n  height: 180px;\n"], ["\n  width: 250px;\n  height: 180px;\n"])));
exports.Graphic = Graphic;
var Box = (0, _styledComponents["default"])(_slice.Box)(templateObject_3 || (templateObject_3 = (0, _tslib.__makeTemplateObject)(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
exports.Box = Box;
Box.defaultProps = {
  width: [1, 3 / 4, 1 / 2]
};
var Anchor = (0, _styledComponents["default"])(_slice.Anchor)(templateObject_4 || (templateObject_4 = (0, _tslib.__makeTemplateObject)(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
exports.Anchor = Anchor;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;